import { getStore } from '~/mobx/AppStore';

export const updateRegionInput = (value: string) => {
    const { regionStore } = getStore();

    regionStore.setRegionName(value);

    // Clear error if previously set and input is now non-empty
    if (regionStore.regionNameError && value.trim().length > 0) {
        regionStore.setRegionNameError(false);
    }
};
